import { createRouter, createWebHistory } from "vue-router"

const routes = [
  {
    path: "/login",
    name: "LoginView",
    component: () => import("../views/LoginView.vue")
  },
  {
    path: "/atendimento",
    name: "ChatView",
    meta: {
      requiresAuth: true,
      title: "Atendimentos",
      module: "atendimento"
    },
    component: () => import("../views/ChatView.vue"),
    props: (route) => ({
      id: route
    })
  },
  {
    path: "/conexoes",
    name: "ConnectionsView",
    meta: {
      requiresAuth: true,
      title: "Conexões",
      module: "conexoes"
    },
    component: () => import("../views/ConnectionsView.vue")
  },
  {
    path: "/setores",
    name: "DepartmentView",
    meta: {
      requiresAuth: true,
      title: "Setores",
      module: "setores"
    },
    component: () => import("../views/DepartmentView.vue")
  },
  {
    path: "/chatbot",
    name: "ChatBotView",
    meta: {
      requiresAuth: true,
      title: "ChatBot",
      module: "chatbot"
    },
    component: () => import("../views/ChatBotsView.vue")
  },
  {
    path: "/usuarios",
    name: "UsersView",
    meta: {
      requiresAuth: true,
      title: "Usuários",
      module: "usuarios"
    },
    component: () => import("../views/UsersView.vue")
  },
  {
    path: "/dashboard",
    name: "DashboardView",
    meta: {
      requiresAuth: true,
      title: "Dashboard",
      module: "dashboard"
    },
    component: function () {
      return import("../views/DashboardView.vue")
    }
  },
  {
    path: "/empresas",
    name: "CompanyView",
    meta: {
      requiresAuth: true,
      title: "Empresas",
      module: "empresas"
    },
    component: () => import("../views/CompanyView.vue")
  },
  {
    path: "/instagram-callback",
    name: "InstagramCallback",
    component: () => import("../views/InstagramCallbackView.vue")
  },
  {
    path: "/facebook-callback",
    name: "FacebookCallback",
    component: () => import("../views/FacebookCallbackView.vue")
  },
  {
    path: "/whatsapp-callback",
    name: "WhatsappCallback",
    component: () => import("../views/WhatsappCallbackView.vue")
  },
  {
    path: "/issues",
    name: "IssuesView",
    meta: {
      requiresAuth: true,
      title: "Chamados (Kanban)",
      module: "issues"
    },
    component: () => import("../views/IssuesView.vue")
  },
  {
    path: "/atendimentos-kanban",
    name: "TicketsKanbanView",
    meta: {
      requiresAuth: true,
      title: "Atendimentos (Kanban)",
      module: "atendimentos-kanban"
    },
    component: () => import("../views/TicketsKanbanView.vue")
  },
  {
    path: "/tags",
    name: "TagsView",
    meta: {
      requiresAuth: true,
      title: "Tags",
      module: "tags"
    },
    component: () => import("../views/TagsView.vue")
  },
  {
    path: "/chaves-mcp",
    name: "McpKeysView",
    meta: {
      requiresAuth: true,
      title: "Chaves MCP",
      module: "chaves-mcp"
    },
    component: () => import("../views/McpKeysView.vue")
  },
  {
    path: "/webhook-failures",
    name: "WebhookFailuresView",
    meta: {
      requiresAuth: true,
      title: "Falhas de Webhook",
      module: "webhook-failures"
    },
    component: () => import("../views/WebhookFailuresView.vue")
  },
  {
    path: "/integracoes",
    name: "IntegrationsView",
    meta: {
      requiresAuth: true,
      title: "Integrações",
      module: "integracoes"
    },
    component: () => import("../views/IntegrationsView.vue")
  },
  {
    path: "/mensagens-prontas",
    name: "QuickMessagesView",
    meta: {
      requiresAuth: true,
      title: "Mensagens Prontas",
      module: "mensagens-prontas"
    },
    component: () => import("../views/QuickMessagesView.vue")
  },
  {
    path: "/configuracoes",
    name: "SettingsView",
    meta: {
      requiresAuth: true,
      title: "Configurações",
      module: "configuracoes"
    },
    component: () => import("../views/SettingsView.vue")
  },
  {
    path: "/planos",
    name: "PlanosView",
    meta: {
      requiresAuth: true,
      title: "Planos"
    },
    component: () => import("../views/PlanosView.vue")
  },
  {
    path: "/bancos",
    name: "BancosView",
    meta: {
      requiresAuth: true,
      title: "Bancos"
    },
    component: () => import("../views/BancosView.vue")
  },
  {
    path: "/configuracoes-fiscais",
    name: "ConfiguracoesFiscaisView",
    meta: {
      requiresAuth: true,
      title: "Configurações Fiscais"
    },
    component: () => import("../views/ConfiguracoesFiscaisView.vue")
  },
  {
    path: "/contas-a-receber",
    name: "ContasReceberView",
    meta: {
      requiresAuth: true,
      title: "Contas a Receber"
    },
    component: () => import("../views/ContasReceberView.vue")
  },
  {
    path: "/campanhas",
    name: "CampaignsView",
    meta: {
      requiresAuth: true,
      title: "Campanhas de Prospecção"
    },
    component: () => import("../views/CampaignsView.vue")
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

router.beforeEach((to, from, next) => {
  const publicPages = ["/login"];
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = localStorage.getItem("token");
  // se a rota for /login e tiver um token ele redireciona para /atendimento
  if (to.path === "/login" && loggedIn) {
    return next("/atendimento");
  }
  // se o token não existir ele redireciona para a tela de login
  if (authRequired && !loggedIn) {
    return next("/login");
  }
  if (to.path === "/") {
    return next("/atendimento");
  }

  // Permission check
  if (to.meta.module) {
    try {
      const userString = localStorage.getItem("user");
      if (userString) {
        const userStore = JSON.parse(userString);
        const moduleKey = to.meta.module;

        let hasAccess = false;

        if (moduleKey === 'dashboard') {
          hasAccess = true;
        } else if (moduleKey === 'empresas') {
          hasAccess = userStore.companyType === 'WL' || userStore.companyType === 'SWL';
        } else if (moduleKey === 'webhook-failures') {
          hasAccess = userStore.companyId == 1;
        } else {
          // 1. Checar modulos empresa
          let blockedByCompany = false;
          if (userStore.companyModules && userStore.companyModules.length > 0) {
            if (!userStore.companyModules.includes(moduleKey)) blockedByCompany = true;
          }

          if (!blockedByCompany) {
            // 2. Checar perfil
            if (userStore.permissions && userStore.permissions.length > 0) {
              hasAccess = userStore.permissions.includes(moduleKey);
            } else {
              // 3. Fallback
              const isUserAdmin = userStore.type === 'admin' || userStore.typeUser === 'admin';
              if (isUserAdmin) hasAccess = true;
              else {
                const attendantDefault = ['atendimento', 'mensagens-prontas', 'tags', 'issues', 'atendimentos-kanban'];
                hasAccess = attendantDefault.includes(moduleKey);
              }
            }
          }
        }

        if (!hasAccess) {
          // redirect to home or some default page
          return next("/atendimento");
        }
      }
    } catch (e) {
      console.error("Error checking permissions", e);
    }
  }

  next();
});

export default router
